export const foundationYear = 2007;
export const newsCount = 3;
export const transparentMenuPages = ['/', '/pcb', '/contracts', '/order', '/order/form', '/contacts'];
